var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToiletFemaleinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 10,
  r: 5
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.333 19h3.334a2 2 0 0 1 1.846 1.23L45 43H19l9.487-22.77A2 2 0 0 1 30.333 19zm.327 40h2.68a2 2 0 0 0 1.966-1.631L38 43H26l2.694 14.369A2 2 0 0 0 30.66 59z"
}))));
export default SvgToiletFemaleinline;